import moment from "moment";
import {num2str} from "../../../../utils/num2str";

export const timerHandler = (fromm) => {
    const timerStart = moment.unix(fromm)
    const timerEnd = moment(timerStart).add(3, 'hours')
    const current = moment()
    const durration = moment.duration(timerEnd.diff(current))
    return durration.asSeconds()
}

export const stringer = (str) => {

    if (`${str}`.length < 2) {
        return `${0}${str}`
    }
    return str
}

export const getTimer = (timer) => {
    var durationValue = moment.duration(timer, 'seconds');
    var hours = Math.floor(durationValue.asHours());
    var mins = Math.floor(durationValue.asMinutes()) - hours * 60;

    const minsFormat = (mins) => {
        return  <>{<span className="red">{stringer(mins)}</span>} {num2str(mins, ["минута", "минуты", "минут"])}</>
    }
    const hoursFormat = (hours) => {
        return <>{<span className="red">{stringer(hours)}</span>} {num2str(hours, ["час", "часа", "часов"])}</>
    }


    if  (hours < 0) return  <>Осталось <span className="red">00</span> часов <span className="red">00</span> минут</>
    return <>Осталось {hours <= 0 ? "" : hoursFormat(hours)} {minsFormat(mins)}</>
}
